module.exports = __webpack_public_path__ + "static/media/completed.5b661d75.svg";